import { render, staticRenderFns } from "./ListagemCollapsesDotacaoOrcamentaria.vue?vue&type=template&id=1d2fcd70&scoped=true"
import script from "./ListagemCollapsesDotacaoOrcamentaria.vue?vue&type=script&lang=js"
export * from "./ListagemCollapsesDotacaoOrcamentaria.vue?vue&type=script&lang=js"
import style0 from "./ListagemCollapsesDotacaoOrcamentaria.vue?vue&type=style&index=0&id=1d2fcd70&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2fcd70",
  null
  
)

export default component.exports